export default __webpack_public_path__ + "static/media/crc-block-ip.8fbcda06.svg";